import React from 'react';
import { useSelector } from '../../../../../../chronusStore/helper';
import Tab from './Tab';
import MeetingMode from './MeetingMode';
import Programs from './Programs';
import ViewToggler from './ViewToggler';

const Filters = ({ filterData, view, children }) => {
  const isCalendarView = useSelector(state => state.eventsListing.isCalendarView);

  const hasContent = () => {
    return (
      (filterData.tab && !isCalendarView) ||
      filterData.meetingMode ||
      filterData.programs ||
      React.Children.count(children) > 0 ||
      view.showToggler
    );
  };

  return (
    hasContent() && (
      <div className="cui-events-listing-filter m-b-md mx-0 row align-items-center">
        { filterData.tab && !isCalendarView && <Tab { ...filterData.tab } /> }

        { filterData.meetingMode && <MeetingMode { ...filterData.meetingMode } /> }

        { filterData.programs && <Programs { ...filterData.programs } /> }

        <div className="ml-auto">
          { children }
          { view.showToggler && <ViewToggler isCalendarView={ isCalendarView }/> }
        </div>
      </div>
    )
  )
}

export default Filters;